export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/download.worker.31579772.worker.js");
}
